import React, { Component } from 'react';
import {Menu, Dropdown, Icon, Select, Tag} from 'antd'

import InnovationCard from '../../components/InnovationCard'
import MiniPaginationCustom from '../../components/default/MiniPaginationCustom'
import ButtonCustom from '../../components/default/ButtonCustom'

import { connect } from 'react-redux'
import { fetchProducts } from '../../actions/products'

const Option = Select.Option;

class InnovationsList extends Component {
    state = {
        start: 0,
        end: 15
    }

    componentDidMount = () => {
        this.props.fetchProducts()
    }

    onPageChange = (page, pageSize) => {
        const start = (page - 1) * pageSize
        const end = start + pageSize
        this.setState({ start, end })
    }
    render() {
        return (
            <div className="page-list-wrap">
                <div className="page-list">
                    <div className="page-list-title gapb-24">งานวิจัยและนวัตกรรม<div className="hr"></div></div>     
                    <div className="is-row sort-and-filter-wrap gapb-16">
                        <div className="is-30 count-innovation">{this.props.products.length} ผลลัพท์</div>
                        <div className="is-70 is-row flex-end">
                            <Select className="select-category" dropdownClassName="select-category-wrap" defaultValue="">
                                <Option value="">หมวดหมู่</Option>
                                <Option value="1">ปลา</Option>
                                <Option value="2">เกษตรกรรม</Option>
                                <Option value="3">ประมง</Option>
                                <Option value="4">อาหารปลา</Option>
                                <Option value="5">เพาะเลี้ยงปลา</Option>
                            </Select>
                        </div>
                    </div>           
                    <div className="filter-tags-wrap gapb-24 gapt-24 is-row flex-align-start">
                        {/* <div className="filter-tags-title gapr-12">หมวดหมู่:</div>
                        <div className="filter-tags-list">
                            <Tag className="tags-item" closable>ปลา</Tag>
                            <Tag className="tags-item" closable>เกษตรกรรม</Tag>
                            <Tag className="tags-item" closable>ประมง</Tag>
                            <Tag className="tags-item" closable>อาหารปลา</Tag>
                            <Tag className="tags-item" closable>เพาะเลี้ยงปลา</Tag>
                        </div> */}
                    </div>
                    <div className="is-row gapb-16 gapr--16 sm-gapr-0 flex-wrap">
                        {
                            this.props.products.slice(this.state.start, this.state.end).map((innovation, index) => (
                                <InnovationCard key={index} innovation={innovation}/>
                            ))
                        }
                    </div>
                    <div className="textAlign-center">
                        <MiniPaginationCustom 
                            color="blue"
                            total={this.props.products.length} 
                            defaultPageSize={15}
                            onChange={this.onPageChange}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		user: state.user,
		products: state.products
	}
}

const mapDispatchToProps = {
	fetchProducts
}

export default connect(mapStateToProps, mapDispatchToProps)(InnovationsList)

